import React from 'react';
import HeaderCommun from './HeaderCommun';

const navigation = [
  { name: 'Accueil', href: '/' },
  { name: 'Nos services', href: '/services' },
  { name: 'À propos', href: '/a-propos' },
  { name: 'Contact', href: '/contact' },
];

const userNavigation = [
  { name: 'Connexion', href: '/login' },
  { name: 'Inscription', href: '/signup' },
];

const HeaderPrincipal = () => (
  <HeaderCommun
    userName="Invité"
    navigation={navigation}
    userNavigation={userNavigation}
    addButtonLabel={null}
    addButtonHref={null}
  />
);

export default HeaderPrincipal;
